@if (label()) {
    <label class="form-label fs-6 text-primary"> {{ label() | translate }} </label>
}

<ul class="list-group shadow-sm" dndDropzone (dndDrop)="onDrop($event)">
    <li class="dropPlaceHolder" dndPlaceholderRef></li>

    @for (item of items(); track item; let i = $index) {
        <li [dndDraggable]="item" dndEffectAllowed="move" class="list-group-item fw-bold">
            @if (showNumber()) {
                <span class="badge rounded-pill text-bg-info text-white">{{ i + 1 }}</span>
                <span class="mx-2">{{ item.text }}</span>
            } @else {
                {{ item.text }}
            }
        </li>
    }
</ul>
